import { Component } from '@angular/core';
import { GlobalEventsManager } from './events-manager.component';
import { AuthGuard } from './shared/auth.guard';
import { PayeeApi } from './shared/sdk/services';
import { Router } from '@angular/router';

@Component({
  selector: 'appFooter',
  templateUrl: './footer.component.html',
  styleUrls: ['./+home/home/style.css']
})

export class FooterComponent {
	year:any;
  	constructor(private eventsManager: GlobalEventsManager,
	              private userApi: PayeeApi,
	              private router: Router,
	              private authGuard: AuthGuard
	) {
  	}

  	ngOnInit() {
  		this.year = new Date().getFullYear();
  	}

}
